import { useTranslation } from 'react-i18next';
import { TableV2 } from '@anytag/shared-atoms';
import { THEME } from '@anytag/shared-constants';
import { ProposalJobDescriptionBreakDownMode } from '@anytag/graphql';
import { formatProposedInfluencersData } from '../utils';
import { useUserProposalContext } from '../UserProposalContext';
import { ProposeInfluencersTableTitle } from '../TableComponents';
import { useInfluencersStateHandler, useProposedInfluencersTable } from '../hooks';
import { RejectProposeInfluencersActionBar } from './RejectInfluencersActionBar';

export interface TemplateProps {
  jdMode?: ProposalJobDescriptionBreakDownMode;
  hasInfluencerCostPermission?: boolean;
}

export const Template = ({ jdMode }: TemplateProps) => {
  const { t } = useTranslation();
  const { userProposal, rejectedInfluencers } = useUserProposalContext();
  const {
    allInfluencerIds,
    selectedInfluencerAccountIds,
    setSelectedInfluencerAccountIds,
    handleSelectSingleInfluencer,
    handleToggleSelectAllInfluencers
  } = useInfluencersStateHandler(rejectedInfluencers);

  const handleSelectAllIds = () => {
    setSelectedInfluencerAccountIds(allInfluencerIds);
  };

  const { columns } = useProposedInfluencersTable({
    jdMode,
    currency: userProposal?.currency || '',
    listSelectedIds: selectedInfluencerAccountIds,
    onRowSelect: handleSelectSingleInfluencer,
    selectButtonProps: { onClick: handleSelectAllIds }
  });

  const { tableData } = formatProposedInfluencersData(rejectedInfluencers, jdMode);

  return !rejectedInfluencers.length ? null : (
    <>
      <ProposeInfluencersTableTitle css={{ borderTop: THEME.border.base }} title={t('Rejected Influencers')} />

      <div css={{ position: 'relative' }}>
        {selectedInfluencerAccountIds.length > 0 ? (
          <RejectProposeInfluencersActionBar
            selectedInfluencerIds={selectedInfluencerAccountIds}
            numberSelected={selectedInfluencerAccountIds.length}
            hasAllSelected={selectedInfluencerAccountIds.length === rejectedInfluencers.length}
            onSelectAll={handleSelectAllIds}
            onToggleSelect={handleToggleSelectAllInfluencers}
          />
        ) : null}

        <TableV2
          noTopBorderRadius
          data={tableData}
          columns={columns}
          rowHeight="62px"
          className="rejected-proposal-table"
          stickyHeader
        />
      </div>
    </>
  );
};
